const ejKeys = [
  'EnterCode',
  'GiftCard',
  'INVALIDRECEIPT',
  'RL_DUPLICATERECEIPT',
  'Op',
  'OrderId',
  'ReturnedItemsEnd',
  'RL_ABORTED',
  'RL_ApprovalNumber',
  'RL_ApprovalDateTime',
  'RL_BankTransfer',
  'RL_CashRounding',
  'RL_ExchangeRate',
  'RL_ExchRate',
  'RF_CheckstatusonNikecom',
  'RL_CouponNumber',
  'RL_CompanyRegistrationNumber',
  'RL_CompNo',
  'RL_DEFECTIVE',
  'RL_EmpNumber',
  'RF_EmployeeVendorNumber',
  'RF_Telephone',
  'RL_Address',
  'RL_Aid',
  'RL_AuthCode',
  'RL_AuthDate',
  'RL_AuthNo',
  'RL_Balance',
  'RL_GCBalance',
  'RL_GeneralManagerName',
  'RL_Card',
  'RL_CardName',
  'RL_CardNo',
  'RL_CertificateNumber',
  'RL_Change',
  'RL_City',
  'RL_ComplimentaryDetail',
  'RL_Contact',
  'RL_Country',
  'RL_CustomerAddress',
  'RL_CertificateName',
  'RL_CustomerFirstName',
  'RL_CustomerLastName',
  'RL_Date',
  'RL_Department1',
  'RL_Difference',
  'RL_DocumentNumber',
  'RL_DocumentType',
  'RL_Email',
  'RL_ExchangeInTender',
  'RL_ExchangeOutTender',
  'RL_FinalPrice',
  'RL_GiftCertificate',
  'RL_GiftCardNo',
  'RL_GiftItem',
  'RL_GIFTITEMRECEIPT',
  'RL_IdentificationNumber',
  'RL_InstallmentMonth',
  'RL_InvoiceNumber',
  'RL_ITEMVOID',
  'RL_Lumpsum',
  'RL_LLCard',
  'RL_Mid',
  'RL_MallCertificate',
  'RL_Months',
  'RL_Name',
  'RL_No',
  'RL_NumberItemReturned',
  'RL_NumberItemSold',
  'RL_OrgDate',
  'RL_OrigInvoiceNo',
  'RL_OrgRegNumber',
  'RL_OrgStoreNumber',
  'RL_OrgTransaction',
  'RL_OrgPrice',
  'RL_PANSeq',
  'RL_PurchaserName',
  'RL_Phone',
  'RL_PostalCode',
  'RL_TaxExempt',
  'RL_TaxExemptNo',
  'RL_PrefName',
  'RL_PromotionName',
  'RL_PriceOvr',
  'RL_QRCode',
  'RL_Quantity',
  'RL_Reg',
  'RL_Reason3',
  'RL_ReferenceNumber',
  'RL_Refund',
  'RL_ReturnedReceipt',
  'RL_ReturnWOReceipt',
  'RL_Requestedby',
  'RL_SerialNum',
  'RL_ShippingAmount',
  'RL_ShipppingInfo',
  'RL_ShippingMethod',
  'RL_ShipStore',
  'RL_Size',
  'RL_State',
  'RL_Store',
  'RL_Subtotal',
  'RL_Tax',
  'RL_TC',
  'RL_Tid',
  'RL_Time',
  'RL_TENDEREXCHANGE',
  'RL_TenderVoid',
  'RL_TRANSACTION',
  'RL_ResumeTransaction',
  'RL_TobeshippedNike',
  'RL_TobeshippedNIKEId',
  'RL_Total',
  'RL_Tran',
  'RL_TRANSACTION_SUSPENDED',
  'RL_VOIDTRANSACTION',
  'RL_StoreCredit',
  'RL_SUSPEND_TRAN',
  'RL_Voucher',
  'RL_YouSaved',
  'TRAININGMODE',
  'TxRef',
  'TxType',
  'UI_Cash',
];
const ejBodyKeys = [
  'OrderId',
  'Op',
  'RL_Amount',
  'RL_AmountRange',
  'RL_AthleteLoginNumber',
  'RL_ContactEmailID',
  'RL_Country',
  'RL_Date',
  'RL_Export',
  'RL_Proceed',
  'RL_EJExportSuccess',
  'RL_EJExportWarning',
  'RL_Proceed',
  'RL_Cancel',
  'RL_DateRange',
  'RL_Delivered',
  'RL_ErrorMsgForOlderDataEJ',
  'RL_ElectronicJournal',
  'RL_EmployeeDiscount',
  'RL_Enter',
  'RL_EnterMin',
  'RL_EnterMax',
  'RL_General',
  'RL_GeneralDiscount',
  'RL_Journal',
  'RL_MatchingTransactions',
  'RL_Modifiers',
  'RL_O2OEvents',
  'RL_OriginalTransactionNumber',
  'RL_Other',
  'RL_PriceOverride',
  'RL_PrintEJ',
  'RL_Promotion',
  'RL_Reg',
  'RL_ResetSearch',
  'RL_Resume',
  'RL_Search',
  'RL_Select',
  'RL_Status',
  'RL_Store',
  'RL_SubTenderType',
  'RL_Suspend',
  'RL_SwitchView',
  'RL_TRAININGMODE',
  'RL_TenderType',
  'RL_TextSearch',
  'RL_Till',
  'RL_Tran',
  'RL_TransactionInformation',
  'RL_TransactionNo',
  'RL_TransactionRepresentation',
  'RL_TransactionType',
  'RL_TransactionUUID',
  'RL_UPCcode',
  'RL_Void',
  'RegisterNumber',
  'RL_StoreSelection',
  'RL_Done',
  'RL_StoreSearch',
  'RL_PurchaseDate',
  'RL_ClearFilter',
  'RL_FromDate',
  'RL_ToDate',
  'RL_Payment',
  'RL_UPC',
  'RL_ErrFromTime',
  'RL_CreditDebitCard',
  'UI_Cash',
  'RL_Complimentary',
  'RL_MoreDetails',
  'RL_KeywordsSearch',
  'RL_KeywordsSearchDesc',
  'RL_SearchLabel',
  'RL_Minimum',
  'RL_Maximum',
  'RL_ErrAmountRequired',
  'RL_ErrMinAmount',
  'RL_AthleteRegisterInfo',
  'RL_AthleteLogin',
  'RL_RegisterNo',
  'RL_RegularSaleReturn',
  'RL_Returns',
  'RL_NoSale',
  'RL_MediaExchange',
  'RL_TransactionType',
  'RL_Reset',
  'RL_PaymentType',
  'GiftCard',
  'RL_CardNoPlaceholder',
  'RL_GiftCardNoPlaceholder',
  'RL_TransactionNo2',
  'RL_OriginalTransactionNo',
  'RL_TillNo',
  'RL_ContactEmail',
  'RL_ErrInvalidEmail',
  'RL_More',
  'RL_UpcCode12Digits',
  'RL_ErrUpcNoDigits',
  'RL_ErrNoRecentTransactions',
  'RL_ErrNoResults',
  'RL_MsgSearchTransactions',
  'RL_MsgAdjustFilters',
  'RL_MsgAdjustSearch',
  'RL_ErrFetchError',
  'RL_LatestTransactions',
  'RL_MatchingTransactions1',
  'RL_MatchingTransactions2',
  'RL_Items',
  'RL_Total',
  'RL_ErrCardNoDigits',
  'RL_ErrGiftCardNoDigits',
  'RL_StartReturn',
  'RL_Receipt',
  'RL_Card',
  'RL_Today',
  'RL_Yesterday',
  'RL_PrintReceipt',
  'RL_ErrPrinterNotConnected',
  'RL_ErrUnexpectedError',
  'RL_InfoMsgOnlyPOS',
  'RL_PrintReceiptInProgress',
  'RL_PrintSuccess',
  'RL_PrintFailure',
  'RL_Ok',
  'RL_ReceiptUnavailable'
];

module.exports = { ejBodyKeys, ejKeys };
